import { ReactElement, useCallback } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { Dialog, Toolbar } from "client/Components";
import {
	createUrlRelativeToEnvironment,
	navigateTo
} from "client_legacy/ndaw/navigator";

export const ResetPasswordTimeoutExpiredDialog = (): ReactElement => {
	const confirmHandler = useCallback(
		(): void => {
			const url: string = createUrlRelativeToEnvironment("/AdminPage/RequestEmergencyAdminAccess");
			navigateTo(url);
		},
		[]
	);

	return (
		<Dialog trackingId="password-timeout-dialog">
			<Dialog.Header title={localize("_LinkExpired")}/>
			<Dialog.Body>
				{localize("_TemporaryPasswordRequestExpired")}
			</Dialog.Body>
			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						kind="primary"
						text={localize("_Ok")}
						onClick={confirmHandler}
						trackingId="ok-button"
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};
ResetPasswordTimeoutExpiredDialog.displayName = "ResetPasswordTimeoutExpiredDialog";